<template>
  <div class="menu-inner">
    <!-- 主菜单 -->
    <div class="menu-main">
      <ul class="menu-list">
        <li class="item" :class="{
          'item-active': firstId == item.id,
          'item-hover': hoverId == item.id,
        }" v-for="(item, index) in menuList" :key="index">
          <a-button type="link" class="item-content" @click="selectItem(item)">
            <img v-if="menu_click.id != item.id && item.level == 1" :src="'/icon/' + item.icon + 'Dark.png'" />
            <img v-if="menu_click.id == item.id && item.level == 1" :src="'/icon/' + item.icon + '.png'" />
            <span class="item-name">{{ item.name }}</span>
          </a-button>
          <span v-if="firstId == item.id" class="item-content-children">
        <li v-for="(child, index1) in item.children" :key="index1"
          :class="{ 'second-menu-active': secondId == child.id }" @click="selectSecondItem(child)"
          class="item-name-children">
          <a-button type="link">{{ child.name }}</a-button>
        </li>
        </span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { setTimeout } from 'timers'
import permission from '../api/permission'
export default {
  name: 'sideMenu',
  data() {
    return {
      isShowSecond: false, //是否展示二级菜单
      menu_click: {}, //点击选择的item
      menu: {}, //展示的ID
      hoverId: '', //移动到第一级菜单的hover状态，注意，这里只能用遍历，不能使用css hover，因为二级菜单需要联动
      firstId: '', //一级菜单选择的ID
      secondId: '', //二级菜单选择的ID
      menuList: [], //菜单数据
      roleId: '',
      url: '',
    }
  },
  methods: {
    getLevel2Item(list, path) {//固定找到第二级菜单，可能path是第三级，第四级
      if (list == null || path == null) {
        return null;
      }
      for (let i in list) {
        if (list[i].path == path) {
          let find = list[i];//从任意子节点返回第二级菜单项
          while (find.level > 2) {
            find = find.parent;
          }
          return find;
        }
        if (list[i].children && list[i].children.length > 0) {
          let findLevel2 = this.getLevel2Item(list[i].children, path)
          if (findLevel2 != null) {
            return findLevel2;
          }
        }

      }
      return null;
    },
    //根据ID找到父节点的ID
    getFatherItem(list, path) {
      let res
      function _getFatherId_fun(list, path, fatherItem) {
        for (let i in list) {
          if (list[i].children && list[i].children.length > 0) {
            _getFatherId_fun(list[i].children, path, list[i])
          }
          if (list[i].path == path) {
            //如果有上一级就返回上一级，没有就返回当前ID
            res = fatherItem ? fatherItem : path
          }
        }
      }
      _getFatherId_fun(list, path)
      return res
    },

    //根据path找到节点
    getItem(list, path) {
      let res
      function _getFatherId_fun(list, path, fatherItem) {
        for (let i in list) {
          if (list[i].children && list[i].children.length > 0) {
            _getFatherId_fun(list[i].children, path, list[i])
          }
          if (list[i].path == path) {
            //如果有上一级就返回上一级，没有就返回当前ID
            res = list[i]
          }
        }
      }
      _getFatherId_fun(list, path)
      return res
    },

    //鼠标移动到第二级菜单
    hoverSecondItem() {
      this.isShowSecond = true
    },
    //鼠标离开第二级菜单
    leaveSecondItem() {
      this.isShowSecond = false
      this.menu = this.menu_click
    },

    //选择一个item
    selectItem(item) {
      this.menu_click = item
      this.menu = item
      this.firstId = item.id
      this.secondId = ''

      //先判断下一级有没有元素，再选择当前元素的第一个
      if (item.children[0]) {
        this.selectSecondItem(item.children[0])
      }
    },

    //选择一个二级菜单
    selectSecondItem(item) {
      let level2 = this.getLevel2Item(this.menuList, item.path)
      if (!level2) return
      let level1 = level2.parent;
      this.menu = level1
      this.menu_click = level1
      this.firstId = level1.id
      this.secondId = level2.id
      //originType点击时设置的跳转来源类型 click
      this.$router.push({ name: item.path, params: { originType: 'click' } })
    },

    //初始化
    init() {
      //获取当前路由
      let level2 = this.getLevel2Item(this.menuList, this.$route.name)
      if (!level2) return
      let level1 = level2.parent;
      this.menu = level1
      // console.log('this.menu', this.menu)
      this.menu_click = level1
      this.firstId = level1.id
      this.secondId = level2.id
    },

    //  装填角色的权限菜单
    listMyPerms(call) {
      //  装填角色的权限菜单
      let self = this
      // console.log('2window菜单-----', window.menuList)

      if (window.menuList && window.menuList.length > 0) {
        // console.log('1window菜单-----', window.menuList)
        this.$set(this, 'menuList', window.menuList)
        let res = { code: 0 }
        call(res)
      } else {
        permission
          .listMyPerms()
          .then((res) => {
            window.menuList = res.data
            this.$set(this, 'menuList', window.menuList)
            call(res)
          })
          .catch((error) => {
            call(error)
          })
      }
    },

    //  递归循环权限菜单 处理可显示渲染的菜单数据
    treeData(data, j, level, parent) {
      if (typeof level == 'undefined') {
        level = 1
      }
      data.level = level
      if (level == 0) {
        data.id = ''
      } else if (level == 1) {//j从1开始
        data.id = j + ''
      } else if (level > 1) {
        data.id = parent.id + '-' + j
      }

      data.name = data.permName
      data.icon = data.permCode
      delete data.permName
      delete data.permCode
      data.parent = parent
      if (data.children && data.children.length > 0) {
        let max = data.children.length;
        for (let i = 0; i < max; i++)
          this.treeData(data.children[i], i + 1, level + 1, data)
      }
    },

    //  获取路由,检查路由的来源的类型 click为点击来源，不执行click的来源的，其他都执行
    fetchData(to, form) {
      if (to.params.type && to.params.type == 'click') {
      } else {
        this.init()
      }
    },
  },
  mounted() {
    this.url = window.location.href
    let self = this

    //  装填角色的权限菜单
    this.listMyPerms((res) => {
      self.init()
    })
    this.$store.dispatch('getUserInfo').then((res) => {
      this.roleId = res.accRole.id
    })
  },
  watch: {
    $route: 'fetchData',
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';

$itemHeight: 40px;

.menu-inner {
  height: calc(100vh - 69px);
  font-size: 14px;
  background: rgb(0, 21, 41);
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.15);
  transition: all 0.2s ease-in-out;
}
.menu-list {
  width: 188px;
  padding: 10px;
  background-color: #fff;
  height: calc(100vh - 69px);
  overflow: auto;
  font-size: 16px;

  .item-content {
    padding: 14px 15px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    width: 100%;
    height: 40px;
    color: #3d3d3d;
    font-size: 16px;
    img {
      width: 18px;
      height: auto;
      vertical-align: middle;
      margin-right: 20px;
    }

    span {
      line-height: 18px;
    }
  }

  .item-active {
    .item-content {
      background-color: #3198ff;
      color: #fff;
      padding: 14px 15px;
      border-radius: 8px;
      display: flex;
      width: 100%;

      img {
        margin-right: 12px;
      }
    }
  }
  .item-name-children {
    display: block;
    height: 40px;
    border-radius: 8px;
    margin-top: 4px !important;
    color: #3d3d3d;
    button {
      padding: 8px 42px;
      color: #249CFF;
      width: 100%;
      height: 40px;
      border-radius: 8px;
      text-align-last: left;
      color: #8b8b8b;
      font-size: 16px;
    }
  }
  .item-name-children:hover,
  .second-menu-active {
    background-color: #eaf6ff;
    button {
      color: #249CFF;
    }
  }
}
</style>
